import { trpc } from '@/shared/api';

/** 추천 상품 목록(어드민) — 배열 순서가 HOME 노출 순서다. */
export const useRecommendedProductsQuery = () =>
  trpc.productManagement.recommendations.list.useQuery();
